// 用户管理接口链接

// 基础路径判断
let protocol = window.location.protocol; // 协议
// 测试环境，域名的时候 http://cmms2.midea.com/
let baseApi = process.env.BASE_API;
if (window.location.href.indexOf('://cmms2') >= 0) {
  baseApi = 'http://cmms2.midea.com/';
}
if (protocol === 'https:') {
  baseApi = baseApi.replace('http:', 'https:');
}

/** 会员等级 */
// 等级列表
export const MEMBER_GET_LEVEL_LIST = '/cmvip/level/list';
// 等级列表 - 不区分品牌
// export const MEMBER_GET_LEVEL_LIST_FOR_BRAND = '/cmvip/level/list';
// 等级权益
export const MEMBET_LEVEL_RIGHT = '/cmvip/level/rights';
// 新增等级
export const MEMBET_LEVEL_SAVE = '/cmvip/level';
// 删除等级
export const MEMBET_DELETED_LEVEL = '/cmvip/level/deleted';
// 商品编码列表
export const COMMODITY_CODE_LIST = '/cmvip/commodity/list';
// 商品编码添加
export const COMMODITY_CODE_SAVE = '/cmvip/commodity/save';
// 商品编码启用/停用
export const COMMODITY_CODE_ENABLE = '/cmvip/commodity/updateEnable';
// 商品编码删除
export const COMMODITY_CODE_DELETE = '/cmvip/commodity/deleted';

/** 勋章管理 */
// 修改勋章
export const MEDAL_MANAGE_UPDATE = '/ccrm2/medalManage/update';
// 勋章统计报表
export const MEDAL_MANAGE_GET_MEDAL_DAILY = '/ccrm2/medalManage/getMedalDaily';
// 勋章规则列表
export const MEDAL_MANAGE_LIST = '/ccrm2/medalManage/list';
// 用户勋章列表
export const MEDAL_MANAGE_GET_USER_MEDAL_LIST = '/ccrm2/medalManage/getUserMedalList';

/** 积分管理 */
// 积分规则列表
export const GET_INTEGRAL_RULE_LIST = '/cmvip/integralRuleApi/getIntegralRuleList';
// 新增积分规则
export const ADD_INTEGRAL_RULE = '/cmvip/integralRuleApi/addIntegralRule';
// 修改积分规则
export const UPDATE_INTEGRAL_RULE = '/cmvip/integralRuleApi/updateIntegralRule';
// 修改积分规则状态
export const UPDATE_INTEGRAL_STATUS = '/cmvip/integralRuleApi/updateIntegralStatus';
// 积分规则列明细查询
export const GET_INTEGRAL_RULE_INFO = '/cmvip/integralRuleApi/getIntegralRuleInfo';
// 积分修改 加减积分
export const UPDATE_USER_INTEGRAL = '/cmvip/integralRuleApi/updateUserIntegral';
// 修改会员积分记录
export const GET_POINT_UPDATE_RECORD_LIST = '/cmvip/integralRuleApi/getPointUpdateRecordList';
// 积分流水
export const GET_POINT_RECORD = '/cmvip/userVipInfo/getPointRecord';

/** 额外积分规则 */
// 查询积分规则列表
export const GET_EXTRA_QUERY_LIST = '/cmvip/extra/queryList';
// 新增更新积分规则
export const GET_EXTRA_SAVE = '/cmvip/extra/save';
// 设置规则启用停用
export const GET_EXTRA_SET_STATUS = '/cmvip/extra/setStatus';
// 查询单条积分规则
export const GET_EXTRA_QUERY_ONE = '/cmvip/extra/queryOne';

/** 会员列表 */
// 会员列表
export const MEMBER_LIST_NEW = '/ccrm2/vipBoard/listNew';
// 上传用户手机号
export const MEMBER_LIST_NEW_FROM_EXCEL = baseApi + '/ccrm2/vipBoard/listNewFromExcel';
// 会员列表导出记录列表
export const LIST_EXPORT_RECORD_LIST = '/cmvip/listExportRecord/list';
// 导出部分查询结果Excel
export const VIP_LIST_NEW_TO_EXCEL = '/ccrm2/vipBoard/listNewToExcel';
// 会员列表获取导出地址
export const LIST_EXPORT_RECORD_GET_BY_ID = '/cmvip/listExportRecord/getById';

/** 黑名单管理 */
// 查询黑名单列表
export const MEMBER_BLACK_LIST = '/cmvip/blacklist/list';
// 黑名单删除
export const MEMBER_BLACK_LIST_DELETE = '/cmvip/blacklist/deleted';
// 黑名单新增
export const MEMBER_BLACK_LIST_SAVE = '/cmvip/blacklist/save';
// 黑名单编辑
export const MEMBER_BLACK_LIST_UPDATE = '/cmvip/blacklist/update';
// 批量添加黑名单
export const BLACK_LIST_UPLOAD = baseApi + '/cmvip/blacklist/upload';
// 获取商品品类
export const EXTRA_QUERY_CATE_GORY = '/cmvip/extra/queryCategory';
// 查询商品
export const EXTRA_QUERY_COMMONDITY = '/cmvip/extra/queryCommodity';

/** 积分/成长值批量操作 */
// 批量补发任务列表
export const MEMBER_BATCH_TASK_LIST = '/cmvip/batchMission/list';
// 批量补发会员成长值/积分
export const MEMBER_BATCH_TASK_UPDATE = '/cmvip/batchMission/batchUpdate';
// 补发明细导出
export const MEMBER_BATCH_TASK_EXPORT = '/cmvip/batchMission/exportMissionRecord';
// 终止批量补发任务
export const MEMBER_BATCH_TASK_STOP = '/cmvip/batchMission/stop';

/** 任务中心 */
// 新增任务
export const INSERT_OR_UPDATE_USER_TASK = '/ccrm2/promote/precisionPromote/insertUserTask';
// 修改任务
export const PROMOTE_UPDATE_USER_TASK = '/ccrm2/promote/precisionPromote/updateUserTask';
// 任务中心-任务列表
export const SELECT_USER_TASK_LIST = '/ccrm2/promote/precisionPromote/selectUserTaskList';
// 任务中心-停用启用任务
export const CHANGE_USER_TASK_STATUS = '/ccrm2/promote/precisionPromote/changeUserTaskStatus';
// 任务中心-改变排序
export const CHANGE_USER_TASK_SERIAL_NUMBER = '/ccrm2/promote/precisionPromote/changeUserTaskSerialNumber';
// 任务中心-根据eventId对应任务数量
export const PRECISION_PROMOTE_GET_USER_TASK_SIZE = '/ccrm2/promote/precisionPromote/getUserTaskSize';
// 任务中心-任务池列表
export const SELECT_USER_TASK_POOL_LIST = '/ccrm2/promote/precisionPromote/selectUserTaskPoolList';
// 任务中心-任务池新增/修改
export const INSERT_OR_UPDATE_USER_TASK_POOL = '/ccrm2/promote/precisionPromote/insertOrUpdateUserTaskPool';
// 任务中心-任务获取品类接口
export const GET_IOT_PRODUCT_TYPE = '/ccrm2/support/getIotProductType';
// 任务指定型号导入
export const DEVICE_TYPE_UPLOAD = baseApi + 'ccrm2/support/getIotProductTypeByUpload';
